import React from 'react'
import { connect } from 'react-redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import styled from 'styled-components'
import { font, colors } from '@chegg-ui/theme'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { WORLDCAT_LOGO } from './utils/testIds'

const WCText = styled.span`
  font-size: ${font.size.px12};
  color: ${colors.grey};
`

const WCContainer = styled.div`
  display: flex;
  align-items: center;
`

interface DispatchProps {
  worldCatLogoClick: () => void
}

export const WorldCatLink: React.FC<DispatchProps> = ({ worldCatLogoClick }) => {
  return (
    <WCContainer>
      <WCText>Powered by </WCText>
      <a
        href="http://www.worldcat.org"
        target="_blank"
        rel="nofollow noopener noreferrer"
        onClick={worldCatLogoClick}
        data-test={WORLDCAT_LOGO}
      >
        <img src={publicAssetUrl('logo-worldcat-oclc.png')} alt="Worldcat logo" />
      </a>
    </WCContainer>
  )
}

const mapDispatchToProps = {
  worldCatLogoClick: () => userClick({ origin: origins.worldCatLogoClick }),
}

export default connect<{}, DispatchProps>(null, mapDispatchToProps)(WorldCatLink)
